import { ApiCall, ApiError } from './apiCall';
import { TokenKeeper } from './TokenKeeper';
import { createExponentialBackoffWait } from 'utility/wait';
import { OIDCClientError } from 'infrastructure/oidc/OIDCClient';

export function createAuthorizedApiCall(authKeeper: TokenKeeper, apiCall: ApiCall): ApiCall {
    return async <T>(url: string, options?: RequestInit | undefined) => {
        const waitWithBackoff = createExponentialBackoffWait();

        for (; ;) {
            try {
                let tokenInfo = await authKeeper.get();
                for (; ;) {
                    try {
                        return await apiCall<T>(url, {
                            ...(options || {}),
                            headers: {
                                Authorization: `Bearer ${tokenInfo.token}`,
                            },
                        });
                    } catch (e) {
                        if (e instanceof ApiError) {
                            if (e.status == 401) {
                                console.debug(`authorization token is expired\ntry refreshing w/ ${tokenInfo.token}`);
                                tokenInfo = await authKeeper.retake();
                                continue;
                            }

                            if (Math.floor(e.status / 100) == 5) {
                                console.debug('server temporary inaccessible\ntry again with some interval');
                                await waitWithBackoff();
                                continue;
                            }
                        }

                        console.error(e);
                        throw e;
                    }
                }
            } catch (e) {
                if (e instanceof OIDCClientError) {
                    throw e;
                }
                if (e instanceof ApiError) {
                    throw e;
                }

                await waitWithBackoff();
            }
        }
    };
}
